module.exports = __webpack_public_path__ + "img/3.265ea96b.png";